<template>
  <component
    :is="forms[step]"
    :type="`email`"
    :csrf="csrf"
    :position="position"
    :links="links"
    :email="email"
    :uid="uid"
    :until="until"
    @go-step="goStep($event)" />
</template>

<script>
import formLoginEmailRequest from './form-login-email-request.vue';
import formLoginResponse from './form-login-response.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUser, faAt, faKey, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
library.add(faUser, faAt, faKey, faArrowLeft);

export default {
  data: function () {
    return {
      forms: ['formLoginEmailRequest', 'formLoginResponse'],
      //
      step: 0,
      email: '',
      until: '',
      uid: 0,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FontAwesomeIcon,
    formLoginEmailRequest,
    formLoginResponse,
  },
  methods: {
    goStep(event) {
      switch (event.step) {
        // ввести email
        case 0:
          //
          break;
        // ввести код
        case 1:
          this.email = event.email;
          break;
      }

      this.uid = event.uid;
      this.until = event.until;

      this.step = event.step;
    },
  },
};
</script>
